Object.defineProperty(exports, "__esModule", { value: true });
var OnClickOutsideHandler = (function () {
    function OnClickOutsideHandler(localNode, callback) {
        var _this = this;
        this.localNode = localNode;
        this.callback = callback;
        this.eventHandler = function (event) {
            var source = event.target;
            var found = false;
            while (source.parentNode) {
                found = (source === _this.localNode);
                if (found)
                    return;
                source = source.parentNode;
            }
            _this.callback(event);
        };
        if (!callback)
            throw new Error("Missing callback");
        document.addEventListener("mousedown", this.eventHandler);
        document.addEventListener("touchstart", this.eventHandler);
    }
    OnClickOutsideHandler.prototype.dispose = function () {
        document.removeEventListener("mousedown", this.eventHandler);
        document.removeEventListener("touchstart", this.eventHandler);
    };
    return OnClickOutsideHandler;
}());
exports.default = OnClickOutsideHandler;
